import React from "react";

export default function IconInsurance() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.62 1.6L4.62 4.71C3.9 5.03 3.43 5.75 3.43 6.54V11C3.43 16.14 6.93 20.95 11.53 22.14C11.84 22.22 12.16 22.22 12.47 22.14C17.07 20.95 20.57 16.14 20.57 11V6.54C20.57 5.75 20.1 5.03 19.38 4.71L12.38 1.6C12.14 1.49 11.86 1.49 11.62 1.6ZM9.29 16.29L6.7 13.7C6.31 13.31 6.31 12.68 6.7 12.29C7.09 11.9 7.72 11.9 8.11 12.29L10 14.17L15.89 8.28C16.28 7.89 16.91 7.89 17.3 8.28C17.69 8.67 17.69 9.3 17.3 9.69L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z"
        fill="currentColor"
      />
    </svg>
  );
}
